// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"dcd137bc","703":"795991eb"}[chunkId] + ".chunk.js";
};